import React from "react";
import { MainErrorComposition } from "@/components/mainComposition";
import { Center, Image } from "@mantine/core";

export default function Error404Page() {
  const mainContent = (
    <div
      style={{
        width: "100%",
        backgroundColor: "#fff",
        height: "800px",
      }}
    >
      <Center h={"100%"}>
        <Image width={500} src="/images/freepik-404.jpg" alt="404" />
      </Center>
    </div>
  );
  return <MainErrorComposition mainContentJSX={mainContent} errorNum={404} />;
}
